<template>
  <div class="language-selector">
    <button class="language-btn" @click="toggleLanguageMenu">
      <span class="language-code">{{ currentLanguageCode }}</span>
      <span class="language-arrow">▼</span>
    </button>
    <div class="language-menu" v-if="showLanguageMenu">
      <button v-for="(item, index) of list" 
              :key="index"
              :disabled="$i18n.locale == item.key"
              @click="handle(item.key)"
              class="language-item"
              :class="{ active: $i18n.locale == item.key }">
        {{ item.name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'change-language',
  data() {
    return {
      list: [
        { key: 'en', name: 'English' }, // 英语
        { key: 'zh-CN', name: '简体中文' }, // 简体中文
        { key: 'zh-TW', name: '繁體中文' }, // 繁体中文
        { key: 'de', name: 'Deutsch' }, // 德语
      ],
      showLanguageMenu: false,
    }
  },
  computed: {
    currentLanguageCode() {
      return this.$i18n.locale.toUpperCase();
    }
  },
  mounted() {
    // 点击外部关闭语言菜单
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handle(value) {
      this.$i18n.locale = value
      localStorage.setItem('change-language', value)
      location.reload()
    },
    toggleLanguageMenu() {
      this.showLanguageMenu = !this.showLanguageMenu;
    },
    handleClickOutside(event) {
      if (!event.target.closest('.language-selector')) {
        this.showLanguageMenu = false;
      }
    }
  },
}
</script>
<style scoped lang="scss">
.language-selector {
  position: relative;
  display: inline-block;
}

.language-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.4rem 0.8rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.85rem;
  font-weight: 500;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
  }
}

.language-code {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8rem;
}

.language-arrow {
  font-size: 0.6rem;
  opacity: 0.7;
  transition: transform 0.3s ease;
}

.language-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  min-width: 120px;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

.language-item {
  display: block;
  width: 100%;
  padding: 0.6rem 1rem;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }

  &.active {
    background: rgba(76, 175, 80, 0.2);
    color: #4CAF50;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
